import * as React from 'react';
import styled, { css } from 'styled-components';

const StyledTextBox = styled.input`
  border: 1px solid lightgrey;
  padding: 0.2rem;

  ${props =>
    props.fullWidth &&
    css`
      width: 100%;
    `}
`;

const TextBox = React.memo(props => <StyledTextBox {...props} />);

export default TextBox;
